import { lazy } from 'react';

const routes = [
  // Redirect route to handle URLs with username (excluding dashboard)
  {
    path: '/:username/:section/*',
    component: lazy(() => import('./components/UsernameRedirect')),
    anonymousAccess: true
  },
  {
    path: '/dashboard',
    component: lazy(() => import('./Dashboard')),
    anonymousAccess: true,
    routes: [
      {
        path: 'bi-dashboard',
        component: lazy(() => import('./pages/desktop/bi-dashboard/Dashboard')),
        mobile: lazy(() =>
          import('./pages/mobile/bi-dashboard-main/DashbaordPage')
        ),
        authKeys: ['ProfitAndLossStatement']
      },
      {
        path: 'errors/error-401',
        component: lazy(() => import('./pages/desktop/errors/Error401')),
        mobile: lazy(() => import('./pages/mobile/errors/Error401'))
      },
      {
        path: 'journal-entries/cash-transaction',
        component: lazy(() =>
          import('./pages/desktop/cash-transaction-new-design/CashTransaction')
        ),
        mobile: lazy(() =>
          import('./pages/mobile/cash-transaction/CashTransaction')
        ),
        authKeys: ['CashTransactionRE']
      },
      {
        path: 'journal-entries/interbank-transaction',
        component: lazy(() =>
          import('./pages/desktop/interbank-transaction/InterbankTransaction')
        ),
        mobile: lazy(() =>
          import('./pages/mobile/interbank-transaction/InterbankTransaction')
        ),
        authKeys: ['InterbankTransactionRE']
      },
      {
        path: 'journal-entries/bank-transaction',
        component: lazy(() =>
          import('./pages/desktop/bank-transaction/SubmitBankTransactionPage')
        ),
        mobile: lazy(() =>
          import('./pages/mobile/bank-transaction/BankTransaction')
        ),
        authKeys: ['BankTransactionRE']
      },
      {
        path: 'journal-entries/bank-transaction-old',
        component: lazy(() =>
          import(
            './pages/desktop/bank-transaction-old/SubmitBankTransactionPage'
          )
        ),
        mobile: lazy(() =>
          import('./pages/mobile/bank-transaction/BankTransaction')
        ),
        authKeys: ['BankTransactionRE']
      },
      {
        path: 'journal-entries/transfer-between-accounts',
        component: lazy(() =>
          import(
            './pages/desktop/transfer-between-accounts/TransferBetweenAccountsPage'
          )
        ),
        mobile: lazy(() =>
          import(
            './pages/mobile/transfer-between-accounts/TransferBetweenAccounts'
          )
        ),
        authKeys: ['TransferBetweenAccountsRE']
      },
      {
        path: 'journal-entries/buy-currency',
        component: lazy(() =>
          import('./pages/desktop/trade-currency/BuyCurrency')
        ),
        mobile: lazy(() => import('./pages/mobile/trade-currency/BuyCurrency')),
        authKeys: ['TradeCurrencyRE']
      },
      {
        path: 'journal-entries/trade-currency',
        component: lazy(() =>
          import('./pages/desktop/trade-currency-redesign/TradeCurrencyBase')
        ),
        mobile: lazy(() => import('./pages/mobile/trade-currency/BuyCurrency')),
        routes: [
          {
            path: 'buy',
            component: lazy(() =>
              import('./pages/desktop/trade-currency-redesign/BuyCurrency')
            )
          },
          {
            path: 'sell',
            component: lazy(() =>
              import('./pages/desktop/trade-currency-redesign/SellCurrency')
            )
          }
        ],
        authKeys: ['TradeCurrencyRE']
      },
      {
        path: 'journal-entries/currency-management',
        component: lazy(() =>
          import('./pages/desktop/currency-management/CurrencyManagement')
        ),
        mobile: lazy(() =>
          import('./pages/mobile/currency-management/CurrencyManagement')
        ),
        authKeys: ['CurrencyManagementList']
      },
      {
        path: 'journal-entries/sell-currency',
        component: lazy(() =>
          import('./pages/desktop/trade-currency/SellCurrency')
        ),
        mobile: lazy(() =>
          import('./pages/mobile/trade-currency/SellCurrency')
        ),
        authKeys: ['TradeCurrencyRE']
      },
      {
        path: 'reports/cheques-list',
        component: lazy(() =>
          import('./pages/desktop/cheques-list/ChequesList')
        ),
        mobile: lazy(() => import('./pages/mobile/cheques-list/ChequesList'))
      },
      {
        path: 'journal-entries/increase-customer-credit',
        component: lazy(() =>
          import(
            './pages/desktop/increase-customer-credit/IncreaseCustomerCredit'
          )
        ),
        mobile: lazy(() =>
          import(
            './pages/mobile/increase-customer-credit/IncreaseCustomerCredit'
          )
        ),
        authKeys: ['IncreaseCustomerCredit']
      },
      {
        path: 'journal-entries/decrease-customer-credit',
        component: lazy(() =>
          import(
            './pages/desktop/decrease-customer-credit/DecreaseCustomerCredit'
          )
        ),
        authKeys: ['DecreaseCustomerCredit']
      },
      {
        path: 'global-ledger/person/registration',
        component: lazy(() =>
          import('./pages/desktop/person-registration/PersonRegistration')
        ),
        mobile: lazy(() =>
          import(
            './pages/mobile/person-registration-new-design/person-registration/PersonRegistration'
          )
        )
      },
      {
        path: 'global-ledger/person/update',
        component: lazy(() =>
          import('./pages/desktop/person-registration/PersonRegistration')
        ),
        mobile: lazy(() =>
          import(
            './pages/mobile/person-registration-new-design/Person-profile/PersonProfile'
          )
        )
      },
      {
        path: 'global-ledger/customer/account-information',
        component: lazy(() =>
          import('./pages/desktop/account-information/AccountInformation')
        ),
        mobile: lazy(() =>
          import('./pages/mobile/account-information/AccountInformation')
        )
      },
      {
        path: 'global-ledger/customer/account-information/department',
        component: lazy(() =>
          import(
            './pages/desktop/account-information-branch/AccountInformation'
          )
        ),
        authKeys: ['BranchesA']
      },
      {
        path: 'global-ledger/customer/account-information/full-screen',
        component: lazy(() =>
          import('./pages/desktop/account-information/AiFullScreen')
        )
      },
      {
        path: 'global-ledger/company/registration',
        component: lazy(() =>
          import('./pages/desktop/company-registration/CompanyRegistration')
        ),
        mobile: lazy(() =>
          import('./pages/mobile/company-registration/CompanyRegistration')
        )
      },
      {
        path: 'global-ledger/company/update',
        component: lazy(() =>
          import('./pages/desktop/company-registration/CompanyRegistration')
        ),
        mobile: lazy(() =>
          import('./pages/mobile/company-registration/CompanyRegistration')
        )
      },
      {
        path: 'global-ledger/branch/registration',
        component: lazy(() =>
          import('./pages/desktop/branch-registration/BranchRegistration')
        ),
        mobile: lazy(() =>
          import('./pages/mobile/branch-registration/BranchRegistration')
        ),
        authKeys: ['BranchAccountRE']
      },
      {
        path: 'global-ledger/branch/update',
        component: lazy(() =>
          import('./pages/desktop/branch-registration/BranchRegistration')
        ),
        mobile: lazy(() =>
          import('./pages/mobile/branch-registration/BranchInformation')
        ),
        authKeys: ['BranchAccountRE']
      },
      {
        path: 'global-ledger/branch/list',
        component: lazy(() =>
          import('./pages/desktop/branches-list/BranchesList')
        ),
        mobile: lazy(() => import('./pages/mobile/branches-list/BranchesList')),
        authKeys: ['BranchesListA']
      },
      {
        path: 'global-ledger/branch/list/archived',
        component: lazy(() =>
          import('./pages/desktop/branches-list/ArchivedBranchesList')
        ),
        mobile: lazy(() =>
          import('./pages/mobile/branches-list/ArchivedBranchesList')
        ),
        authKeys: ['BranchesListA']
      },
      {
        path: 'global-ledger/branch/list/department',
        component: lazy(() =>
          import('./pages/desktop/branches-list-branch/BranchesList')
        ),
        authKeys: ['BranchesA']
      },
      {
        path: 'global-ledger/branch/account-information',
        component: lazy(() =>
          import('./pages/desktop/branch-account/BranchAccount')
        ),
        mobile: lazy(() =>
          import('./pages/mobile/branch-account/BranchAccount')
        )
      },
      {
        path: 'global-ledger/branch/account-information/department',
        component: lazy(() =>
          import('./pages/desktop/branch-account-branch/BranchAccount')
        ),
        authKeys: ['BranchesA']
      },
      {
        path: 'global-ledger/branch/account-information/full-screen',
        component: lazy(() =>
          import('./pages/desktop/branch-account/BranchAccountFullScreen')
        )
      },
      {
        path: 'global-ledger/mirror-branch/account-information',
        component: lazy(() =>
          import('./pages/desktop/mirror-branch-account/MirrorBranchAccount')
        )
      },
      {
        path: 'global-ledger/receiver/receivers-list',
        component: lazy(() =>
          import('./pages/desktop/receivers-list/ReceiversList')
        ),
        mobile: lazy(() =>
          import('./pages/mobile/receivers-list/ReceiversList')
        ),
        authKeys: ['ReceiversListA']
      },
      {
        path: 'reports/pending-transactions-list',
        component: lazy(() =>
          import('./pages/desktop/pending-transactions/PendingTransactionsList')
        ),
        mobile: lazy(() =>
          import('./pages/mobile/pending-transactions/PendingTransactionsList')
        ),
        routes: [
          {
            path: '',
            component: lazy(() =>
              import('./pages/desktop/pending-transactions/drafts/DraftsPage')
            ),
            mobile: lazy(() =>
              import('./pages/mobile/pending-transactions/drafts/DraftsPage')
            )
          }
        ],
        authKeys: ['PendingDraftsList']
      },
      {
        path: 'journal-entries/unknown-bank-transactions-list',
        component: lazy(() =>
          import(
            './pages/desktop/unknown-bank-transactions-list/UnknownTransactionsList'
          )
        ),
        mobile: lazy(() =>
          import(
            './pages/mobile/unknown-bank-transactions-list/UnknownTransactionsList'
          )
        ),
        authKeys: ['UnknownBankTransactionsA']
      },
      {
        path: 'journal-entries/bank-transactions-list',
        component: lazy(() =>
          import('./pages/desktop/bank-transactions/BankTransactionsList')
        ),
        mobile: lazy(() =>
          import('./pages/mobile/Bank-transactions/TransactionsList')
        ),
        authKeys: ['UnknownBankTransactionsA']
      },
      {
        // wallet
        path: 'credit-account',
        component: lazy(() =>
          import(
            './pages/desktop/credit-account-newDesign/CustomerCreditAccount'
          )
        ),
        mobile: lazy(() =>
          import('./pages/mobile/credit-account/CustomerCreditAccount')
        ),
        authKeys: ['ExchangersCreditAccountA']
      },
      {
        // customers credit
        path: 'customer-credit-account',
        component: lazy(() =>
          import(
            './pages/desktop/credit-account-newDesign/CustomerCreditAccount'
          )
        ),
        mobile: lazy(() =>
          import('./pages/mobile/credit-account/CustomerCreditAccount')
        ),
        authKeys: ['SupportCreditCustomer']
      },
      {
        path: 'organization/list/organizations-list',
        component: lazy(() =>
          import('./pages/desktop/organizations-list/OrganizationsList')
        ),
        authKeys: ['OrganizationListA']
      },
      {
        path: 'organization/list/organizations-credit-info',
        component: lazy(() =>
          import('./pages/desktop/organizations-list/OrganizationCreditInfos')
        ),
        mobile: lazy(() =>
          import('./pages/mobile/organizations-ist/OrganizationCreditInfos')
        ),
        authKeys: ['OrganizationListA']
      },
      {
        path: 'archivedcustomer/list',
        component: lazy(() =>
          import('./pages/desktop/archived-accounts-list/ArchivedAccountList')
        ),
        mobile: lazy(() =>
          import('./pages/mobile/customers-list/CustomersList')
        ),
        authKeys: ['ArchivedAccountsA']
      },
      {
        path: 'customer/list',
        component: lazy(() =>
          import('./pages/desktop/customers-list/CustomersList')
        ),
        mobile: lazy(() =>
          import('./pages/mobile/customers-list/CustomersList')
        ),
        authKeys: ['CustomersListA']
      },
      {
        path: 'customer/list/department',
        component: lazy(() =>
          import('./pages/desktop/customers-list-branch/CustomersList')
        ),
        authKeys: ['BranchesA']
      },
      {
        path: 'customer/list/profile',
        component: lazy(() =>
          import(
            './pages/desktop/person-registration-newDesign/page/ProfilePage'
          )
        ),
        mobile: lazy(() =>
          import('./pages/mobile/customers-list/CustomerProfile')
        )
      },
      {
        path: 'system-account/list',
        component: lazy(() =>
          import('./pages/desktop/system-accounts/SystemAccountsList')
        ),
        mobile: lazy(() =>
          import('./pages/mobile/system-accounts/SystemAccountsList')
        ),
        authKeys: ['SystemAccountsList']
      },
      {
        path: 'system-account/list/department',
        component: lazy(() =>
          import('./pages/desktop/system-accounts-branch/SystemAccountsList')
        ),
        authKeys: ['BranchesA']
      },
      {
        path: 'accounts/banks-list',
        component: lazy(() =>
          import('./pages/desktop/bankbook-list/BankAccountsList')
        ),
        mobile: lazy(() =>
          import('./pages/mobile/bank-accounts-list/BankAccountsList')
        ),
        authKeys: ['BankAccountsList']
      },
      {
        path: 'accounts/banks-list/archived',
        component: lazy(() =>
          import('./pages/desktop/bankbook-list/ArchivedBankAccountsList')
        ),
        mobile: lazy(() =>
          import('./pages/mobile/bank-accounts-list/ArchivedBankAccountsList')
        ),
        authKeys: ['BankAccountsList']
      },
      {
        path: 'accounts/banks-list/department',
        component: lazy(() =>
          import('./pages/desktop/bankbook-list-branch/BankAccountsList')
        ),
        authKeys: ['BranchesA']
      },
      {
        path: 'draft/submission',
        component: lazy(() =>
          import('./pages/desktop/draft-submission-redesign/DraftSubmission')
        ),
        mobile: lazy(() =>
          import('./pages/mobile/draft-submission/DraftSubmissionPage')
        ),
        routes: [
          {
            path: 'outgoing',
            component: lazy(() =>
              import(
                './pages/desktop/draft-submission-redesign/outgoing-draft/OutgoingDraftSubmissionBase'
              )
            ),
            mobile: lazy(() =>
              import(
                './pages/mobile/draft-submission/outgoing/OutgoingDraftSubmission'
              )
            )
          },
          {
            path: 'incoming',
            component: lazy(() =>
              import(
                './pages/desktop/draft-submission-redesign/incoming-draft/IncomingDraftSubmissionBase'
              )
            ),
            mobile: lazy(() =>
              import(
                './pages/mobile/draft-submission/incoming/IncomingDraftSubmission'
              )
            )
          },
          {
            path: 'misc',
            component: lazy(() =>
              import(
                './pages/desktop/draft-submission-redesign/misc/MiscDraftSubmissionBase'
              )
            ),
            mobile: lazy(() =>
              import(
                './pages/mobile/draft-submission/misc/MiscellaneousDraftSubmission'
              )
            )
          }
        ],
        authKeys: ['DraftRE']
      },
      {
        path: 'draft/submission/one-way',
        component: lazy(() =>
          import('./pages/desktop/draft-submission-noversion/DraftSubmission')
        ),
        mobile: lazy(() =>
          import('./pages/mobile/draft-submission-noversion/DraftSubmission')
        ),
        authKeys: ['DraftRE']
      },
      {
        path: 'draft/submission/mirrorIncoming',
        mobile: lazy(() =>
          import(
            './pages/mobile/draft-submission/MirrorIncomingDraftSubmission'
          )
        ),
        authKeys: ['DraftRE']
      },
      {
        path: 'draft/draft-conduction',
        component: lazy(() =>
          import('./pages/desktop/draft-conduction/DraftConduction')
        ),
        mobile: lazy(() =>
          import('./pages/mobile/draft-conduction-new-design/DraftConduction')
        ),
        authKeys: ['DraftExecutionR']
      },
      {
        path: 'draft/draft-conduction-redesign',
        component: lazy(() =>
          import('./pages/desktop/draft-conduction-redesign/DraftConduction')
        ),
        mobile: lazy(() =>
          import('./pages/mobile/draft-conduction-new-design/DraftConduction')
        ),
        authKeys: ['DraftExecutionR']
      },
      {
        path: 'draft/draft-documents-list',
        component: lazy(() =>
          import('./pages/desktop/drafts-list/DraftDocumentsList')
        ),
        mobile: lazy(() =>
          import('./pages/mobile/draft-documents-list/DraftDocumentsList')
        ),
        authKeys: ['DraftDocumentsListA']
      },
      {
        path: 'draft/orders',
        component: lazy(() =>
          import('./pages/desktop/drafts-orders-list/DraftOrderPage')
        ),
        routes: [
          {
            path: 'list',
            component: lazy(() =>
              import('./pages/desktop/drafts-orders-list/DraftOrderList')
            ),
            mobile: lazy(() =>
              import('./pages/mobile/draft-orders/DraftOrdersList')
            ),
            authKeys: ['DraftDocumentsListA']
          }
        ]
      },
      {
        path: 'draft/orders',
        component: lazy(() =>
          import('./pages/desktop/drafts-orders-list/DraftOrderPage')
        ),
        routes: [
          {
            path: 'list/department',
            component: lazy(() =>
              import('./pages/desktop/drafts-orders-list-branch/DraftOrderList')
            ),
            authKeys: ['BranchesA']
          }
        ]
      },
      {
        path: 'draft/unrealized-drafts-list',
        component: lazy(() =>
          import('./pages/desktop/drafts-list/UnrealizedDraftsList')
        ),
        mobile: lazy(() =>
          import('./pages/mobile/unrealized-drafts-list/UnrealizedDraftsList')
        )
      },
      {
        path: 'reports/profit-and-loss-statement',
        component: lazy(() =>
          import(
            './pages/desktop/profit-and-loss-statement-newDesign/ProfitAndLossStatement'
          )
        ),
        mobile: lazy(() =>
          import(
            './pages/mobile/profit-and-loss-statement/ProfitAndLossStatement'
          )
        ),
        authKeys: ['ProfitAndLossStatement']
      },
      {
        path: 'bi-dashboard',
        component: lazy(() => import('./pages/desktop/bi-dashboard/Dashboard')),
        mobile: lazy(() =>
          import('./pages/mobile/bi-dashboard/ProfitAndLossStatement')
        )
      },
      {
        path: 'reports/debtor-and-creditor-list',
        component: lazy(() =>
          import(
            './pages/desktop/debtor-and-creditorList/DebtorAndCreditorList'
          )
        ),
        mobile: lazy(() =>
          import('./pages/mobile/debtor-and-creditorList/DebtorAndCreditorList')
        ),
        authKeys: ['DebtorCreditorA']
      },
      {
        path: 'report/debtor-and-creditor-list/department',
        component: lazy(() =>
          import(
            './pages/desktop/debtor-and-creditor-branch/DebtorAndCreditorList'
          )
        ),
        authKeys: ['BranchesA']
      },
      {
        path: 'reports/commissions-report',
        component: lazy(() =>
          import('./pages/desktop/commissions-report/CommissionsReport')
        ),
        mobile: lazy(() =>
          import('./pages/mobile/commissions-report/CommissionsReport')
        ),
        authKeys: ['CommissionReportsA']
      },
      {
        path: 'system-management/system-settings/update',
        component: lazy(() =>
          import('./pages/desktop/system-management/SystemSettings')
        ),
        mobile: lazy(() =>
          import('./pages/mobile/system-management/SystemSettings')
        )
      },
      {
        path: 'system-management/operation-of-the-day',
        component: lazy(() =>
          import('./pages/desktop/day-operation/DayOperation')
        ),
        mobile: lazy(() => import('./pages/mobile/day-operation/DayOperation')),
        authKeys: ['DayOperation']
      },
      {
        path: 'accounts/banks-list/bank-information',
        component: lazy(() =>
          import('./pages/desktop/bankbook-information/BankbookInformation')
        ),
        mobile: lazy(() => import('./pages/mobile/bank-accounts-list/BankBook'))
      },
      {
        path: 'accounts/banks-list/bank-information/department',
        component: lazy(() =>
          import(
            './pages/desktop/bankbook-information-branch/BankbookInformation'
          )
        ),
        authKeys: ['BranchesA']
      },
      {
        path: 'accounts/banks-list/bank-information/full-screen',
        component: lazy(() =>
          import(
            './pages/desktop/bankbook-information/BankbookInformationFullScreen'
          )
        )
      },
      {
        path: 'reports/operation-of-the-day',
        component: lazy(() =>
          import('./pages/desktop/day-operation/DayOperation')
        ),
        mobile: lazy(() => import('./pages/mobile/day-operation/DayOperation')),
        authKeys: ['DayOperation']
      },
      {
        path: 'reports/payment-order',
        component: lazy(() =>
          import('./pages/desktop/payment-order/PaymentOrderList')
        ),
        // mobile: lazy(() =>
        //   import('./pages/mobile/payment-order/PaymentOrderList')
        // ),
        authKeys: ['PaymentOrderA']
      },
      {
        path: 'reports/trade-currencies-list',
        component: lazy(() =>
          import('./pages/desktop/trade-currencies-list/TradeCurrenciesList')
        ),
        mobile: lazy(() =>
          import('./pages/mobile/trade-currencies-list/TradeCurrenciesList')
        ),
        authKeys: ['TradeCurrencyA']
      },
      {
        path: 'report/trade-currencies-list/department',
        component: lazy(() =>
          import('./pages/desktop/trade-currencies-branch/TradeCurrenciesList')
        ),
        authKeys: ['BranchesA']
      },
      {
        path: 'reports/excel-data-output',
        component: lazy(() =>
          import('./pages/desktop/excel-data-output/ExcelTotalDataOutput')
        ),
        mobile: lazy(() =>
          import('./pages/mobile/excel-data-output/ExcelTotalDataOutput')
        ),
        authKeys: ['ExcelPI']
      },
      {
        path: 'reports/financial-operation',
        component: lazy(() =>
          import('./pages/desktop/financial-operation/FinancialOperation')
        ),
        mobile: lazy(() =>
          import('./pages/mobile/financial-operation/FinancialOperation')
        ),
        authKeys: ['FinancialOperationsA']
      },
      {
        path: 'reports/notes',
        component: lazy(() => import('./pages/desktop/notes-list/NotesList')),
        mobile: lazy(() => import('./pages/mobile/notes-list/NotesList')),
        authKeys: ['notesA']
      },
      {
        path: 'errors/errorUnhandled',
        component: lazy(() => import('./pages/desktop/errors/ErrorUnhandled'))
      },
      {
        path: 'errors/errorNoConnection',
        component: lazy(() =>
          import('./pages/desktop/errors/ErrorNoConnection')
        ),
        mobile: lazy(() => import('./pages/mobile/errors/ErrorNoConnection'))
      },
      {
        path: 'sample-page',
        component: lazy(() => import('./pages/SamplePage'))
      }
      // ********************** must be deleted **********************************
    ]
  },
  {
    path: '/*',
    component: lazy(() => import('./pages/desktop/errors/Error404')),
    mobile: lazy(() => import('./pages/mobile/errors/Error404'))
  }
];

export const settingsRoutes = [
  {
    path: '/welcome',
    component: lazy(() => import('./pages/desktop/welcome/WelcomePage')),
    mobile: lazy(() => import('./pages/mobile/welcome/WelcomePage')),
    anonymousAccess: true
  },
  {
    path: '/system-settings',
    component: lazy(() =>
      import('./pages/desktop/system-management/IsolatedSystemSettings')
    ),
    mobile: lazy(() =>
      import('./pages/mobile/system-management/IsolatedSystemSettings')
    ),
    anonymousAccess: true
  }
];

export default routes;
